import React, { useMemo } from "react";
import { HiOutlineShieldCheck } from "react-icons/hi";
import { formatCount, percentOf } from "pages/ServiceProvider/SpSetting/AiCreditsUsage/aiUsageChartUtils";
import PlatformAiUsageBreakdownTrendChart from "./PlatformAiUsageBreakdownTrendChart";
import {
  AI_USAGE_STATUS_LABELS,
  mapByStatusForChart,
  STATUS_TREND_COLORS,
} from "./aiUsageOverview.utils";

const PlatformAiUsageByStatusChart = ({
  items = [],
  trends = [],
  loading = false,
  error = "",
  from,
  to,
  granularity = "day",
}) => {
  const mappedItems = useMemo(() => mapByStatusForChart(items), [items]);

  const totals = useMemo(() => {
    const calls = mappedItems.reduce(
      (sum, row) => sum + (Number(row.call_count) || 0),
      0
    );
    return { calls };
  }, [mappedItems]);

  const failedRow = mappedItems.find((row) => row.status_key === "failed");
  const successRow = mappedItems.find((row) => row.status_key === "success");

  return (
    <PlatformAiUsageBreakdownTrendChart
      title="Call outcomes"
      subtitle="Success, failure, and cache hit mix over time"
      icon={HiOutlineShieldCheck}
      iconClassName="bg-emerald-50 text-emerald-600"
      trends={trends}
      keyField="status_key"
      from={from}
      to={to}
      granularity={granularity}
      loading={loading}
      error={error}
      valueKey="call_count"
      topN={3}
      labelFn={(key) => AI_USAGE_STATUS_LABELS[key] || key}
      colorFn={(key) => STATUS_TREND_COLORS[key] || "#94a3b8"}
      metricItems={
        mappedItems.length > 0
          ? [
              { label: "Total calls", value: formatCount(totals.calls) },
              {
                label: "Failed",
                value: failedRow ? formatCount(failedRow.call_count) : "0",
              },
              {
                label: "Success rate",
                value: percentOf(successRow?.call_count ?? totals.calls, totals.calls),
              },
            ]
          : []
      }
      emptyTitle="No outcome data"
      emptyHint="Call status breakdown appears when usage logs include success/failed/cached status."
    />
  );
};

export default PlatformAiUsageByStatusChart;
